import React from 'react';
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md'; 
import "../styles/FilterPanel.css";

interface FilterPanelProps {
  showPaper: boolean;
  setShowPaper: (value: boolean) => void;
  showGlass: boolean;
  setShowGlass: (value: boolean) => void;
}

export default function FilterPanel({
  showPaper,
  setShowPaper,
  showGlass,
  setShowGlass,
}: FilterPanelProps) {
  const renderCheckbox = (
    label: string,
    value: boolean,
    onToggle: (val: boolean) => void
  ) => (
    <div className="checkboxRow" onClick={() => onToggle(!value)}>
      {value ? (
        <MdCheckBox size={20} color="#2eaf4a" />
      ) : (
        <MdCheckBoxOutlineBlank size={20} color="#555" />
      )}
      <span>{label}</span>
    </div>
  );

  return (
    <div className="panel">
      <div className="title">Waste containers</div>
      {renderCheckbox('Paper', showPaper, setShowPaper)}
      {renderCheckbox('Glass', showGlass, setShowGlass)}
    </div>
  );
}


